import { createAsyncThunk } from "@reduxjs/toolkit";

import * as addressAPI from "../../../api/address";
import { IAddress } from "../../../models/address";

/**
 * Load user's saved addresses.
 *
 * Fetches all addresses saved to the user's account. These addresses are
 * displayed as quick-select options in the shipping and billing address forms.
 * Only available for authenticated users.
 *
 * @returns {Promise<IAddress[]>} Promise resolving to array of user addresses
 *
 * @example
 * // Load addresses on checkout page mount
 * dispatch(loadUserAddresses());
 *
 * @example
 * // Reload addresses after user adds a new address
 * await dispatch(loadUserAddresses()).unwrap();
 *
 * @sideEffects
 * - Updates `data.addresses` with fetched addresses via extraReducers
 * - Logs to console in debug mode
 */
export const loadUserAddresses = createAsyncThunk(
    "checkout/loadUserAddresses",
    async (): Promise<IAddress[]> => {
        console.debug("Loading user addresses...");
        const addresses = await addressAPI.listUserAddresses();
        return addresses;
    },
);
